/**
 * Classify a workspace-slug failure.
 *
 * Reserved and taken are both `409` and differ only by error code: a reserved
 * name can NEVER be had (it is a static route or an app-owned segment), while
 * a taken one is merely held by someone else. Telling a user the first is the
 * second sends them hunting for a workspace that cannot exist.
 *
 * Every surface that creates, renames or restores a workspace has to draw that
 * line, and each one wants its own copy for it — so what is shared is the
 * CLASSIFICATION, not the message. Restating `code === "…"` at each call site
 * is what let a fourth surface (the settings modal's General tab) keep showing
 * the server's raw English after the code changed.
 */
export type SlugErrorKind = "reserved" | "taken";

export function slugErrorKind(
  err: { readonly code?: string } | null | undefined,
): SlugErrorKind | null {
  if (!err) return null;
  if (err.code === "slug_reserved") return "reserved";
  if (err.code === "conflict") return "taken";
  return null;
}
